import { render } from "./WalletModal.vue?vue&type=template&id=59a5cdd3&scoped=true"
import script from "./WalletModal.vue?vue&type=script&lang=js"
export * from "./WalletModal.vue?vue&type=script&lang=js"

import "./WalletModal.vue?vue&type=style&index=0&id=59a5cdd3&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a5cdd3"]])

export default __exports__